{
  "name": "practice-video-app",
  "version": "2.3.2",
  "author": "Ionic Framework",
  "homepage": "https://ionicframework.com/",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build --prod",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "lint": "ng lint"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.2.17",
    "@angular/cdk": "21.2.14",
    "@angular/common": "21.2.17",
    "@angular/compiler": "21.2.17",
    "@angular/core": "21.2.17",
    "@angular/forms": "21.2.17",
    "@angular/platform-browser": "21.2.17",
    "@angular/platform-browser-dynamic": "21.2.17",
    "@angular/pwa": "21.2.17",
    "@angular/router": "21.2.17",
    "@angular/service-worker": "21.2.17",
    "@capacitor-mlkit/barcode-scanning": "^8.1.0",
    "@capacitor/android": "8.4.1",
    "@capacitor/app": "8.1.0",
    "@capacitor/browser": "8.0.3",
    "@capacitor/camera": "8.2.0",
    "@capacitor/core": "8.4.1",
    "@capacitor/device": "8.0.2",
    "@capacitor/haptics": "8.0.2",
    "@capacitor/ios": "8.4.1",
    "@capacitor/keyboard": "8.0.3",
    "@capacitor/local-notifications": "8.2.0",
    "@capacitor/push-notifications": "^8.1.1",
    "@capacitor/screen-orientation": "^8.0.1",
    "@capacitor/share": "8.0.1",
    "@capacitor/status-bar": "8.0.2",
    "@capacitor/toast": "8.0.1",
    "@capawesome/capacitor-file-picker": "8.0.3",
    "@ctrl/tinycolor": "4.2.0",
    "@ionic/angular": "8.8.12",
    "@ionic/angular-server": "8.8.12",
    "@ionic/cli": "^7.2.1",
    "@ionic/core": "8.8.12",
    "@ionic/pwa-elements": "3.4.0",
    "@ionic/storage-angular": "^4.0.0",
    "@swimlane/ngx-charts": "^23.1.0",
    "@trapezedev/configure": "7.1.4",
    "angularx-qrcode": "21.0.5",
    "audit": "^0.0.6",
    "e": "^0.2.33",
    "fix": "0.0.6",
    "image-resize": "^1.4.1",
    "ionicons": "8.0.13",
    "ngx-image-cropper": "9.1.6",
    "rxjs": "7.8.2",
    "short-crypt": "4.0.0",
    "tslib": "2.8.1",
    "webpack": "5.108.1",
    "webpack-dev-middleware": "8.0.3",
    "zone.js": "0.16.2"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "21.2.17",
    "@angular-eslint/builder": "21.4.0",
    "@angular-eslint/eslint-plugin": "21.4.0",
    "@angular-eslint/eslint-plugin-template": "21.4.0",
    "@angular-eslint/schematics": "21.4.0",
    "@angular-eslint/template-parser": "21.4.0",
    "@angular/cli": "21.2.17",
    "@angular/compiler-cli": "21.2.17",
    "@angular/language-service": "21.2.17",
    "@capacitor/assets": "^3.0.5",
    "@capacitor/cli": "8.4.1",
    "@ionic/angular-toolkit": "^12.3.0",
    "@types/jasmine": "6.0.0",
    "@typescript-eslint/eslint-plugin": "8.62.0",
    "@typescript-eslint/parser": "8.62.0",
    "baseline-browser-mapping": "2.10.40",
    "eslint": "10.6.0",
    "eslint-plugin-import": "2.32.0",
    "eslint-plugin-jsdoc": "63.0.10",
    "eslint-plugin-prefer-arrow": "1.2.3",
    "jasmine-core": "6.3.0",
    "jasmine-spec-reporter": "~7.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.2.0",
    "ts-node": "^10.9.2",
    "typescript": "5.9.3"
  },
  "description": "An Ionic project",
  "browserslist": [
    "ios_saf >16.4",
    "Chrome >=107",
    "ChromeAndroid >=112",
    "Firefox >=106",
    "Edge >=107",
    "Safari >=16.1",
    "iOS >=16.1"
  ]
}
